import { useEffect } from 'react';
import { useStatusStore } from '../../stores/statusStore';
import styles from './ConnectionStatus.module.scss';

export default function ConnectionStatus() {
  const { status, dbStatus, lastChecked, startMonitoring, stopMonitoring, checkHealth } =
    useStatusStore();

  useEffect(() => {
    startMonitoring();
    return () => stopMonitoring();
  }, [startMonitoring, stopMonitoring]);

  const statusConfig = {
    connected: { label: 'Connected', className: styles.connected },
    disconnected: { label: 'Disconnected', className: styles.disconnected },
    checking: { label: 'Checking...', className: styles.checking },
  };

  const config = statusConfig[status];

  const formatLastChecked = (): string => {
    if (!lastChecked) return '';
    const seconds = Math.floor((Date.now() - lastChecked) / 1000);
    if (seconds < 10) return 'just now';
    if (seconds < 60) return `${seconds}s ago`;
    return `${Math.floor(seconds / 60)}m ago`;
  };

  return (
    <div className={styles.wrapper}>
      <button
        className={`${styles.indicator} ${config.className}`}
        onClick={checkHealth}
        title={`Status: ${config.label}\nDatabase: ${dbStatus}\nLast checked: ${formatLastChecked()}`}
        type="button"
      >
        <span className={styles.dot} />
        <span className={styles.label}>{config.label}</span>
      </button>
    </div>
  );
}
